import { Component, OnInit } from '@angular/core';

interface ContactCard {
  id: string;
  iconImg: string;
  labelKey: string;
  titleKey: string;
  textKey: string;
  copyValue: string;
  href?: string;
  external?: boolean;
  actionIconImg: string;
  actionKey: string;
}

interface OfficialChannel {
  id: string;
  iconImg: string;
  labelKey: string;
  titleKey: string;
  textKey: string;
  url: string;
}

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.scss',
})
export class ContactUsComponent implements OnInit {
  copiedKey = '';

  contactCards: ContactCard[] = [
    {
      id: 'address',
      iconImg: 'assets/as/21.webp',
      labelKey: 'atw.contact.cards.address.label',
      titleKey: 'atw.contact.cards.address.title',
      textKey: 'atw.contact.cards.address.text',
      copyValue:
        'جمهورية مصر العربية، محافظة القاهرة، منطقة جاردن سيتي، 21 شارع أمين سامي، متفرع من شارع القصر العيني – الطابق الثاني.',
      href: 'https://maps.app.goo.gl/Yp3V36RCxrBAygFr6?g_st=iw',
      external: true,
      actionIconImg: 'assets/as/47.webp',
      actionKey: 'atw.contact.actions.openMap',
    },
    {
      id: 'phone',
      iconImg: 'assets/as/46.webp',
      labelKey: 'atw.contact.cards.phone.label',
      titleKey: 'atw.contact.cards.phone.title',
      textKey: 'atw.contact.cards.phone.text',
      copyValue: '01033750675',
      href: 'tel:+201033750675',
      actionIconImg: 'assets/as/46.webp',
      actionKey: 'atw.contact.actions.callNow',
    },
    {
      id: 'whatsapp',
      iconImg: 'assets/as/25.webp',
      labelKey: 'atw.contact.cards.whatsapp.label',
      titleKey: 'atw.contact.cards.whatsapp.title',
      textKey: 'atw.contact.cards.whatsapp.text',
      copyValue: '01033750675',
      href: 'https://wa.me/201033750675',
      external: true,
      actionIconImg: 'assets/as/3.webp',
      actionKey: 'atw.contact.actions.openWhatsApp',
    },
    {
      id: 'email',
      iconImg: 'assets/as/37.webp',
      labelKey: 'atw.contact.cards.email.label',
      titleKey: 'atw.contact.cards.email.title',
      textKey: 'atw.contact.cards.email.text',
      copyValue: 'in@ahmedelshahat.net',
      href: 'mailto:in@ahmedelshahat.net',
      actionIconImg: 'assets/as/37.webp',
      actionKey: 'atw.contact.actions.emailUs',
    },
  ];

  officialChannels: OfficialChannel[] = [
    {
      id: 'linkedin',
      iconImg: 'assets/as/42.webp',
      labelKey: 'atw.contact.channels.items.linkedin.label',
      titleKey: 'atw.contact.channels.items.linkedin.title',
      textKey: 'atw.contact.channels.items.linkedin.text',
      url: 'https://www.linkedin.com/in/ahmed-elshahat-recruitment',
    },
    {
      id: 'facebook',
      iconImg: 'assets/as/43.webp',
      labelKey: 'atw.contact.channels.items.facebook.label',
      titleKey: 'atw.contact.channels.items.facebook.title',
      textKey: 'atw.contact.channels.items.facebook.text',
      url: 'https://www.facebook.com/share/1Jp8p1fxo9/?mibextid=wwXIfr',
    },
    {
      id: 'instagram',
      iconImg: 'assets/as/44.webp',
      labelKey: 'atw.contact.channels.items.instagram.label',
      titleKey: 'atw.contact.channels.items.instagram.title',
      textKey: 'atw.contact.channels.items.instagram.text',
      url: 'https://www.instagram.com/ahmed.elshahat.recruitment/',
    },
    {
      id: 'snapchat',
      iconImg: 'assets/as/45.webp',
      labelKey: 'atw.contact.channels.items.snapchat.label',
      titleKey: 'atw.contact.channels.items.snapchat.title',
      textKey: 'atw.contact.channels.items.snapchat.text',
      url: 'https://snapchat.com/t/auXis1Zk',
    },
    {
      id: 'whatsapp-channel',
      iconImg: 'assets/as/25.webp',
      labelKey: 'atw.contact.channels.items.whatsappChannel.label',
      titleKey: 'atw.contact.channels.items.whatsappChannel.title',
      textKey: 'atw.contact.channels.items.whatsappChannel.text',
      url: 'https://whatsapp.com/channel/0029Vb6QJXRDDmFRPW6U3F27',
    },
    {
      id: 'google-maps',
      iconImg: 'assets/as/47.webp',
      labelKey: 'atw.contact.channels.items.maps.label',
      titleKey: 'atw.contact.channels.items.maps.title',
      textKey: 'atw.contact.channels.items.maps.text',
      url: 'https://maps.app.goo.gl/Yp3V36RCxrBAygFr6?g_st=iw',
    },
  ];

  constructor() {}

  ngOnInit(): void {}

  copyText(value: string, key: string): void {
    if (typeof navigator === 'undefined' || !navigator.clipboard) {
      return;
    }

    navigator.clipboard.writeText(value).then(() => {
      this.copiedKey = key;

      setTimeout(() => {
        this.copiedKey = '';
      }, 1600);
    });
  }

  trackByContactCard(index: number, item: ContactCard): string {
    return item.id;
  }

  trackByChannel(index: number, item: OfficialChannel): string {
    return item.id;
  }
}
